import { useState } from "react";
import { format, subDays } from "date-fns";
import { Flame, Download } from "lucide-react";
import { ShareBar } from "@/components/ShareBar";
import { useVisitor } from "@/lib/visitor";
import { intentById } from "@/lib/intents";

const KEY = "vp_dev_days";
const days = () => JSON.parse(localStorage.getItem(KEY) || "[]");

const streakOf = (list) => {
  const set = new Set(list);
  let n = 0;
  while (set.has(format(subDays(new Date(), n), "yyyy-MM-dd"))) n += 1;
  return n;
};

export const recordWatch = () => {
  const today = format(new Date(), "yyyy-MM-dd");
  const list = days();
  if (!list.includes(today)) localStorage.setItem(KEY, JSON.stringify([...list, today].slice(-60)));
  return streakOf(days());
};

const message = (n) => (n >= 2 ? `${n} days in a row! Keep growing, one day at a time.` : "Day 1 done! See you again tomorrow.");

export const useStreak = () => {
  const { intent } = useVisitor();
  const [streak, setStreak] = useState(() => streakOf(days()));
  const isMember = intentById(intent)?.audience === "member";
  return { streak, isMember, onWatch: () => setStreak(recordWatch()) };
};

export const StreakNote = ({ streak, testId = "devotional-streak" }) => {
  if (streak >= 7 && streak % 7 === 0) return <MilestoneCard days={streak} />;
  return (
  <p className="flex items-center gap-2 rounded-2xl bg-amber-50 px-4 py-2.5 text-sm font-medium text-amber-800 animate-in fade-in slide-in-from-bottom-1 duration-500" data-testid={testId}>
    <Flame className="h-4 w-4 shrink-0 text-amber-500" /> {message(streak)}
  </p>
  );
};

const MilestoneCard = ({ days }) => {
  const api = `${process.env.REACT_APP_BACKEND_URL}/api`;
  return (
    <div className="space-y-3 rounded-3xl bg-gradient-to-br from-amber-50 to-white p-4 ring-1 ring-amber-200 animate-in fade-in zoom-in-95 duration-500" data-testid="devotional-milestone">
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-800"><Flame className="h-4 w-4 text-amber-500" /> Amazing! {days} days in a row with God. Share the joy!</p>
      <img src={`${api}/public/milestone/${days}.jpg`} alt={`${days} days in a row`} className="w-full rounded-2xl shadow" data-testid="devotional-milestone-card" />
      <div className="flex flex-wrap items-center gap-2">
        <ShareBar title={`${days} days in a row with God`} url={`${api}/share/milestone/${days}`} testPrefix="milestone-share" />
        <a href={`${api}/public/milestone/${days}.jpg`} download={`victory-${days}-days.jpg`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-medium text-[#1D64B4]" data-testid="milestone-save"><Download className="h-4 w-4" /> Save image</a>
      </div>
    </div>
  );
};
